import React from "react";
import "./WhyUs.css";

function WhyUs() {
  const points = [
    {
      title: "Prenatal care",
      desc: "Regular monitoring, nutritional counselling and recommendations for a healthy pregnancy for mother and child."
    },
    {
      title: "High-risk pregnancy care",
      desc: "Specialised care with access to advanced diagnostic testing and treatment of complications, including twins and triplets."
    },
    {
      title: "Ultrasound and pregnancy scans",
      desc: "Advanced imaging for precise pregnancy ultrasounds, tracking fetal growth and monitoring the mother's health."
    },
    {
      title: "Postpartum care",
      desc: "Postnatal services that support recovery after delivery, including treatment for postpartum depression and help with lactation."
    }
  ];

  return (
    <section className="band soft" id="childbirth">
      <div className="wrap">
        <div className="split">
          <div>
            <p className="eyebrow">Childbirth at Lakshmi</p>
            <h2 className="h-sec">Normal delivery is the plan, not the exception.</h2>
            <p className="lead-in" style={{ marginTop: "22px", fontSize: "18px", lineHeight: "1.6" }}>
              At our hospital, 90% of patients have a normal delivery. Where more support is wanted, we offer painless delivery through epidural services to make labour as comfortable as it can be.
            </p>
            <ul className="soft-list">
              {points.map((pt, idx) => (
                <li key={idx}>
                  <span className="n">&mdash;</span>
                  <div>
                    <b>{pt.title}</b>
                    <span>{pt.desc}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <figure className="fig fig-tall">
            <img
              src="/img/uplaods/Pregnancy.webp"
              alt="A mother and her newborn in a quiet moment together"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/img/uplaods/african-american-pregnant-woman-touching.avif";
              }}
            />
          </figure>
        </div>
      </div>
    </section>
  );
}

export default WhyUs;

